/* © 2020 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, February 05, 2020
 * For information or permission request, email info@aetonixsystems.com
 */

import PropTypes from "prop-types";
import React from "react";
import SubForm from "./Subform";

export default function ExternalForm(props, context) {
	var schema = props.schema;
	var data = schema.external;
	var defaultData = props.defaultValue || {};
	var externalForms = context.externalForms || {};
	var dataId = props.dataId;

	var parts = data.split(":");

	var formExternal = parts[1];
	var formSchema = externalForms[formExternal];
	if (!formSchema) return null;

	return <SubForm schema={formSchema} defaultData={defaultData} dataId={dataId} onChange={props.onChange} />;
}

ExternalForm.contextTypes = {
	dispatch: PropTypes.func,
	localize: PropTypes.func,
	externalForms: PropTypes.object
};
